
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"34","viewBox":"0 0 42 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42 13.6c0-3.755-2.792-6.8-6.222-6.8-2.95 0-5.422 2.242-6.061 5.255-.179.84.535 1.545 1.394 1.545.86 0 1.523-.727 1.876-1.51.506-1.12 1.56-1.89 2.79-1.89 1.72 0 3.112 1.509 3.112 3.4 0 1.879-1.385 3.4-3.117 3.4H1.7a1.7 1.7 0 100 3.4h34.082c3.434 0 6.218-3.051 6.218-6.8zM28 6.8C28 3.045 25.208 0 21.778 0c-3.436 0-6.222 3.04-6.222 6.796 0 .002.001.004.004.004h1.551c.86 0 1.523-.728 1.876-1.51.506-1.12 1.56-1.89 2.79-1.89 1.72 0 3.112 1.509 3.112 3.4 0 1.878-1.396 3.4-3.121 3.4H4.811a1.7 1.7 0 100 3.4h16.973C25.218 13.6 28 10.549 28 6.8zm7.778 22.1c0 2.818-2.096 5.1-4.667 5.1-2.578 0-4.667-2.282-4.667-5.085 0-.008.007-.015.015-.015H28c.86 0 1.516.827 2.184 1.367.258.21.578.333.927.333.86 0 1.556-.754 1.556-1.7 0-.94-.698-1.7-1.568-1.7H11.033a1.7 1.7 0 110-3.4h20.078c2.578 0 4.667 2.29 4.667 5.1z","fill":"currentColor"}})])
          )
        }
      }
    